const FRAME = 'fill-card stroke-border';
const BAR = 'fill-muted';
const LINE = 'fill-border';
const ACCENT = 'fill-foreground';

const BrowserFrame = ({ children }: { children: React.ReactNode }) => (
  <svg
    viewBox="0 0 200 96"
    className="h-20 w-full"
    role="img"
    preserveAspectRatio="xMidYMid meet"
    aria-hidden="true"
  >
    <rect x="1" y="1" width="198" height="94" rx="8" className={FRAME} strokeWidth="1.5" />
    <path d="M1 9 a8 8 0 0 1 8-8 h182 a8 8 0 0 1 8 8 v6 H1 Z" className={BAR} />
    <circle cx="10" cy="8" r="1.6" className={LINE} />
    <circle cx="16" cy="8" r="1.6" className={LINE} />
    <circle cx="22" cy="8" r="1.6" className={LINE} />
    {children}
  </svg>
);

export const WidgetIllustration = () => (
  <BrowserFrame>
    <rect x="14" y="26" width="80" height="5" rx="2.5" className={LINE} />
    <rect x="14" y="38" width="120" height="4" rx="2" className={LINE} />
    <rect x="14" y="48" width="100" height="4" rx="2" className={LINE} />
    <rect x="14" y="58" width="110" height="4" rx="2" className={LINE} />
    <circle cx="178" cy="78" r="11" className={ACCENT} />
    <path
      d="M173 78 h10 M173 75 h10 M173 81 h6"
      className="stroke-card"
      strokeWidth="1.4"
      strokeLinecap="round"
    />
  </BrowserFrame>
);

export const EmbedIllustration = () => (
  <BrowserFrame>
    <rect x="14" y="26" width="70" height="5" rx="2.5" className={LINE} />
    <rect x="14" y="38" width="60" height="4" rx="2" className={LINE} />
    <rect x="14" y="48" width="64" height="4" rx="2" className={LINE} />
    <rect
      x="108"
      y="24"
      width="78"
      height="62"
      rx="6"
      className="fill-muted stroke-border"
      strokeWidth="1.2"
    />
    <rect x="108" y="24" width="78" height="13" rx="6" className={ACCENT} />
    <path d="M108 32 h78" className="stroke-border" strokeWidth="0" />
    <rect x="116" y="46" width="50" height="8" rx="4" className="fill-card" />
    <rect x="128" y="60" width="50" height="8" rx="4" className="fill-card" />
    <rect x="116" y="74" width="40" height="6" rx="3" className="fill-card" />
  </BrowserFrame>
);
